import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const vehicleExpenseLocaleModule: LocaleModule = {
  name: "vehicleExpense",
  messages: { en: en, it: it },
};
